export default {};

export const PathsWithoutHeaders = ['/rivigoClientPincodeServiceability'];
